import React, { Component } from 'react';

export default class NoMatchPage extends Component {
  render() {
    return <p>No match</p>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/no-match.js